import { CSSData, TemplateData } from '@shared/ui/elements/types';
import { LanguageCode, LogLevelType } from '@shared/content/types';
import {
  CallsConfiguration,
  IdConnectConfiguration,
  IdsAvailableType,
} from '@idConnect/types';
import { ConsentManagerDataLayerEvent } from '@shared/consentManagerDataLayer/types';
import { Content as RevocationContent } from '@revocationPopup/popupWindow/templating/types';
import { ConfigType, ListenerCallback } from '@shared/config/types';

export type QueueCommand = () => void;

export type DataObject = {
  clientConfig?: {
    CALLS_CONFIG: CallsConfiguration;
    IDCONNECT_CONFIG: IdConnectConfiguration;
  };
  popupContent?: TemplateData;
  customizationCSS?: 'object' | CSSData;
  revocationContent?: RevocationContent;
  wereIdsDispatched?: boolean;
  showRevocationErrorMessage?: boolean;
  showErrorModal?: boolean;
  consentManagerDataLayer?: ConsentManagerDataLayerEvent[];
};

export type APIMethodsType = {
  addEventListener?: (event: string, callback: ListenerCallback) => void;
  getIdGraphEntry?: (entryKey?: string) => IdsAvailableType;
  getUtiqConsentStatus?: () => boolean;
  getConfig?: () => ConfigType;
  setConfig?: (config: ConfigType) => void;
  handleConsentChange?: (
    isConsentGranted?: boolean,
    options?: { syncConsentOnAccept?: boolean; clearConsent?: boolean },
  ) => void;
  handleDataClear?: () => void;
  removeEventListener?: (event: string, callback: ListenerCallback) => void;
  resetLoggingLevel?: () => void;
  revokeConsentWithPopup?: () => void;
  showConsentModal?: () => void;
  setVerboseLoggingLevel?: () => void;
  setLogLevel?: (level: LogLevelType) => void;
  showConsentManager?: CallableFunction;
  showRevocationPopupWindow?: () => void;
  syncVersionCookiesOnConsent?: () => void;
};

export type APIMethodNameType = keyof APIMethodsType;

export type Functions = {
  dispatchConsentCall?: () => void;
  changeLanguage?: ((currentLanguage: LanguageCode) => void)[];
};

export type PayloadObject = {
  [hostname: string]: {
    consentParsed: string;
    consentState: string;
    consentVersion?: number;
    consentVersionPrevious?: number;
    name: string;
    value: string;
  };
};

export type ProcessConsentChangeFunction = (
  isConsentGranted: boolean,
  payload: PayloadObject,
) => Promise<void>;

export function isIframeEventType(x: unknown): x is IframeEventType {
  if (typeof x !== 'object') return false;
  if (x === null) return false;

  if (!('origin' in x && typeof x.origin === 'string')) return false;

  if (!('data' in x && typeof x.data === 'object')) return false;
  if (x.data === null) return false;
  if (!('action' in x.data && typeof x.data.action === 'string')) return false;

  return true;
}

export type IframeEventType = {
  origin: string;
  source: MessageEventSource;
  data: { action: string; description: object };
};
